import { render, staticRenderFns } from "./BusServermanageAppList.vue?vue&type=template&id=68d82c98&scoped=true&"
import script from "./BusServermanageAppList.vue?vue&type=script&lang=js&"
export * from "./BusServermanageAppList.vue?vue&type=script&lang=js&"
import style0 from "./BusServermanageAppList.vue?vue&type=style&index=0&id=68d82c98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d82c98",
  null
  
)

export default component.exports